export class Prepayment {
  public amount: number;
  public date: Date;
  public description: string;
  public creditInvoiceNumber: string;
  public reserved: boolean;
}
